import {useEffect, useRef, useState} from "react";
import {getBankBalances, getInvoicesForBank} from "../../api/Api";
import {clampToCents} from "../../util/unitutils";
import {getBaseColumnSearchProps, getColumnSearchProps} from "../widget/SearchProps";
import {Link, useParams} from "react-router";
import {BankTransactionType} from "../../api/Constants";
import {toFSDateTime} from "../../util/timeutils";
import {Card, Divider, Table, Row, Col} from "antd";

export const BankAccountView = ({refresh, onRefresh, onApiFail, props}) => {
    const params = useParams();
    const {bankId} = params;
    const [accountData, setAccountData] = useState([]);
    const [account, setAccount] = useState({});

    const searchInput = useRef(null);

    useEffect(() => {
        getBankBalances().then(r => {
            r.forEach(account => {
                if (account.id === bankId) {
                    setAccount(account);
                }
            });
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [bankId, refresh, onApiFail]);

    useEffect(() => {
        if (bankId === undefined) {
            return;
        }
        getInvoicesForBank(bankId).then(r => {
            const result = r.map(l => {
                return {
                    ...l,
                    key: l.id
                }
            }).sort((a, b) => (new Date(b.date)) - (new Date(a.date)))

            let balance = 0;
            let i;
            for (i=result.length-1; i>=0; i--) {
                const line = result[i];
                balance += parseFloat(line.amount);
                line.balance = clampToCents(balance);
                line.row = i;
            }
            setAccountData(result);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [refresh, onApiFail, bankId]);

    const accountColumns = [
        {
            title: 'Row',
            dataIndex: 'row',
            key: 'row'
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (val, record) => {
                const {id, type} = record;
                if ((type === BankTransactionType.Payment) || (type === BankTransactionType.Expense)) {
                    // link only payment and expense type transactions
                    return <Link to={`/transaction/${id}`}>$ {val}</Link>
                }
                return `$ ${val}`
            },
            ...getColumnSearchProps(`amount`, searchInput),
        },
        {
            title: 'Confirmed By',
            dataIndex: 'username',
            key: 'username',
            // sorter: (a, b) => a.username.toLowerCase().localeCompare(b.username.toLowerCase()),
        },
        {
            title: 'Info',
            dataIndex: 'invoiceNumber',
            key: 'invoiceNumber',
            render: (val, record, index) => {
                // for now test for the existence of the invoice number
                if (val) {
                    return <Link to={`/invoice/${record.invoiceId}`}>{val}</Link>
                } else if (record.notes) {
                    return record.notes;
                } else {
                    // fixme make this better
                    return "Transfer"
                }
            },
            ...getBaseColumnSearchProps("invoiceNumber", searchInput),
            onFilter: (value, record) => {
                const {invoiceNumber} = record;
                let columnValue = "";
                if (invoiceNumber) {
                    columnValue = invoiceNumber;
                } else if (record.notes) {
                    columnValue = record.notes;
                }
                return columnValue.toString().toLowerCase().includes(value.toLowerCase())
            },
        },
        {
            title: 'Other',
            dataIndex: 'amount',
            key: 'other',
            render: (val, record, index) => {
                if (record.type === BankTransactionType.Expense) {
                    return record.company;
                } else if (record.type === BankTransactionType.Invoice) {
                    return record.firstname;
                }
            },
            ...getBaseColumnSearchProps("company", searchInput),
            onFilter: (value, record) => {
                let columnValue = "";
                if (record.type === BankTransactionType.Expense) {
                    columnValue = record.company;
                } else if (record.type === BankTransactionType.Invoice) {
                    columnValue = record.firstname;
                }
                return columnValue.toString().toLowerCase().includes(value.toLowerCase())
            },
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            render: (val, record, index) => {
                return BankTransactionType.Label[val]
            },
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render: (val) => toFSDateTime(new Date(val)),
            sorter: (a, b) => (new Date(a.date))- (new Date(b.date)),
        },
        {
            title: 'Balance',
            dataIndex: 'balance',
            key: 'balance',
            render: (val, record, index) => {
                return `$ ${val}`
            }
        }
    ];

    const tablePagination = {
        defaultPageSize: 100,
        showSizeChanger: true,
        pageSizeOptions: [100, 200, 300, 400]
    }
    const cardStyle={
        textAlign: 'left'
    }

    const {accountName} = account;

    return <div>
        <div style={{textAlign: 'left', marginLeft: '25px', fontSize: 'large'}}>
            <Row>
                <Col span={2} style={{fontSize: 'large'}}>
                    <b>Account:</b>
                </Col>
                <Col style={{fontSize: 'large'}}>
                    <b>{accountName}</b>
                </Col>
            </Row>
        </div>
        <Divider/>
        <Card style={cardStyle} title={<b>Transactions</b>}>
            <Table dataSource={accountData} columns={accountColumns} pagination={tablePagination}/>
        </Card>
    </div>
}